import React, { useState } from "react";
import Calendar from "react-calendar";
import ModalComponent from "../Modal";
import dayjs from "dayjs";
import styled from "styled-components";
import Colors from "../../Constant/Colors";

// Custom styles for the Calendar component
const StyledCalendar = styled(Calendar)`
  border: none;
  width: 100%;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);

  .react-calendar__navigation {
    display: flex;
    justify-content: space-between;
    padding: 1em;
    background-color: ${Colors.primary};
    border-radius: 15px 15px 0 0;
    color: white;
    font-size: 1.2em;
  }

  .react-calendar__navigation button {
    color: white;
    background: none;
    border: none;
    font-size: 1.2em;
    cursor: pointer;
    transition: transform 0.2s ease;
  }

  .react-calendar__navigation button:hover {
    transform: scale(1.1);
  }

  .react-calendar__tile {
    max-width: 100%;
    padding: 1em;
    background: none;
    text-align: center;
    font-size: 1em;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .react-calendar__tile--active {
    background-color: ${Colors.primary};
    color: white;
    border-radius: 10px;
  }

  .react-calendar__tile--now {
    background: ${Colors.lightGrayColor2};
    border-radius: 10px;
    color: black;
  }

  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #0078d7;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background: #e0e0e0;
    border-radius: 10px;
  }
`;

const CalendarComponent = ({ closeModal, openCalendar, onChange, date, maxDate, minDate }) => {
  const selectDate = (date) => {
    onChange(dayjs(date).format('YYYY-MM-DD'));
    closeModal();
  };

  return (
    <ModalComponent
      closeModal={closeModal}
      openModal={openCalendar}
      heading={"Select Date"}
    >
      <StyledCalendar
        onChange={selectDate}
        value={date}
        maxDate={maxDate}
        minDate={minDate}
      />
    </ModalComponent>
  );
};

export default CalendarComponent;
